module.exports = __webpack_public_path__ + "static/media/bg-gradient-v2.8a87a83d.svg";